import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { useRouter } from 'next/router';
const recreateOnNavigation = Component => {
  const InnerComponent = props => {
    const {
      name
    } = props;
    const router = useRouter();
    const key = `${router.asPath}:${name}`;
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      key: key
    }));
  };
  InnerComponent.WrappedComponent = Component;
  InnerComponent.displayName = `recreateOnNavigation(${Component.displayName || Component.name || 'Component'})`;
  return InnerComponent;
};
export default recreateOnNavigation;
//# sourceMappingURL=recreateOnNavigation.js.map